import { cva } from '@/styled-system/css';

export const propertyCardPhotoBodyRecipe = cva({
  base: {
    borderStartStartRadius: 'obj.default',
    borderEndEndRadius: '0',
    gridColumn: '1 / -1',
    gridRow: '1 / -1',
    position: 'relative',
    zIndex: 0,
  },
  variants: {
    appearance: {
      large: {
        'borderStartEndRadius': 'obj.default',
        'borderEndStartRadius': '0',

        /* Prevent rounded corners from disappearing during slide transition */
        '& .c11n_photo-carousel__root': {
          borderRadius: `{radii.obj.default} {radii.obj.default} 0px 0px`,
        },
      },
      small: {
        borderStartEndRadius: 'obj.default',
        borderEndStartRadius: '0',
      },
      horizontal: {
        borderStartEndRadius: '0',
        borderEndStartRadius: 'obj.default',
        minBlockSize: `{sizes.PropertyCard.PhotoWrapper.horizontal.minHeight}`,
      },
    },
    loading: {
      true: {
        backgroundColor: 'bg.softer',
        backgroundImage:
          'linear-gradient(to right, {colors.bg.softer}, {colors.bg.softest}, {colors.bg.softer})',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '{386px}',

        _motionReduce: {
          animation: 'none',
        },
        _motionSafe: {
          animationName: 'shimmer',
          animationDuration: '{durations.1500}',
          animationIterationCount: 'infinite',
        },
      },
      false: {},
    },
  },
});
